module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-left.89c69277.svg";